import React, { useState } from 'react';
import moment from "moment";
import './timelinestyles.css';
import { getFormattedTransitdate } from '../common/utils';
import { getDDMMYYYY, getDDMMYYYYHHMMSS, getHyphenDDMMMYYYYHHMM, getDDMMYYYYHHMM } from '../common/utils';


const TimelineModal = ({ showModal, onClose, timelineData, truckCourier, expectedTripEndTimeStamp, revisedTripEndTimeStamp, actualDeliveryDate,deliveryDate }) => {
    if (!showModal) return null;
    const [showAllInTransit, setShowAllInTransit] = useState(false);
    const [expandedLegsIndex, setExpandedLegsIndex] = useState(null);
    const filteredTimelineData = timelineData ? timelineData.slice().reverse() : [];

    const inTransitEvents = filteredTimelineData.filter(e =>
        (e.intransit_status || e.current_loc_status || "").toLowerCase().trim() === "in transit"
    );
    const nonInTransitEvents = filteredTimelineData.filter(e =>
        (e.intransit_status || e.current_loc_status || "").toLowerCase().trim() !== "in transit"
    );

    const visibleInTransit = showAllInTransit
        ? inTransitEvents.map((event, idx) => ({ ...event, newlyShown: true }))
        : inTransitEvents.slice(0, 1);

    var uniqueTimelineData = []
    if (truckCourier) {
        uniqueTimelineData = filteredTimelineData
    }
    else {
        // uniqueTimelineData = [...visibleInTransit, ...nonInTransitEvents];
        let inTransitCount = 0;
        uniqueTimelineData = filteredTimelineData.filter((e) => {
            const isInTransit = (e.intransit_status || e.current_loc_status || "").toLowerCase().trim() === "in transit";
            e.newlyShown = false;
            if (isInTransit) {
                if (showAllInTransit) {
                    e.newlyShown = true;
                }
                if (showAllInTransit || inTransitCount === 0) {
                    inTransitCount++;
                    return true;
                }
                return false;
            }
            return true;
        });
    }

    const blockHeight = 125;
    const legBlockHeight = 70;

    const firstInTransitIndex = uniqueTimelineData.findIndex(
        e => (e.intransit_status || e.current_loc_status || "").toLowerCase().trim() === "in transit"
    );
    const lastInTransitIndex = uniqueTimelineData.findLastIndex(
        (e) => (e.intransit_status || e.current_loc_status || "").toLowerCase().trim() === "in transit"
    );

    // var greenLineHeight = showAllInTransit ? (lastInTransitIndex + 1) * blockHeight : 0;
    var greenLineHeight = 0;
    let greenLineTopOffset = 0;

    if (showAllInTransit && firstInTransitIndex !== -1 && lastInTransitIndex !== -1) {
        greenLineHeight = (lastInTransitIndex - firstInTransitIndex + 1) * blockHeight;
        greenLineTopOffset = firstInTransitIndex * blockHeight;
    }

    if (showAllInTransit) {
        if (
            expandedLegsIndex !== null &&
            expandedLegsIndex <= lastInTransitIndex
        ) {
            const expandedEvent = uniqueTimelineData[expandedLegsIndex];
            const legCount = Array.isArray(expandedEvent?.legs) ? expandedEvent.legs.length : 0;
            greenLineHeight += legCount * legBlockHeight;
        }
    }

    // var expected_eta = expectedTripEndTimeStamp ? getDDMMYYYYHHMMSS(expectedTripEndTimeStamp) : ""
    // var revised_eta = revisedTripEndTimeStamp ? getDDMMYYYYHHMMSS(revisedTripEndTimeStamp) : ""
    var expected_eta = expectedTripEndTimeStamp ? getDDMMYYYYHHMMSS(expectedTripEndTimeStamp) : "";

    let revised_eta = "";

    if (deliveryDate) {
        revised_eta = getDDMMYYYYHHMMSS(deliveryDate);
    } else if (actualDeliveryDate) {
        revised_eta = getDDMMYYYYHHMMSS(actualDeliveryDate);
    } else if (revisedTripEndTimeStamp) {
        revised_eta = getDDMMYYYYHHMMSS(revisedTripEndTimeStamp);
    } else {
        revised_eta = "";
}






    return (
        <div className={truckCourier ? "modal-overlay1" : ""}>
            <div className={truckCourier ? "modal-content1" : ""}>
                {truckCourier &&
                    <button className="close-button1" onClick={onClose}>X</button>}
                {/* <h2 className={truckCourier ? "modal-title1" : "modal-title-ftl"}>Consignment Tracking Timeline</h2> */}
                <h2
                    className={truckCourier ? "modal-title1" : "modal-title-ftl"}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}
                >
                    <span>Consignment Tracking Timeline</span>
                    {truckCourier ? "" :
                        <>

                            <span style={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#212529', lineHeight: 1.5, fontWeight: 600 }}>
                                <span style={{ fontWeight: 'bold', marginRight: "5px" }}>Expected ETA: </span>
                                <span>{expected_eta}</span>
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#212529', lineHeight: 1.5, fontWeight: 600 }}>
                                <span style={{ fontWeight: 'bold', marginRight: "5px" }}>Revised ETA: </span>
                                <span>{revised_eta}</span>
                            </span>
                        </>}
                </h2>
                {truckCourier ?
                    <div className='d-flex justify-content-between'>
                        <span style={{ display: 'flex', alignItems: 'center', fontSize: '12px', color: '#212529', lineHeight: 1.5, fontWeight: 600, marginRight: "10px" }}>
                            <span style={{ fontWeight: 'bold', marginRight: "5px" }}>Expected ETA: </span>
                            <span>{expected_eta}</span>
                        </span>
                        <span style={{ display: 'flex', alignItems: 'center', fontSize: '12px', color: '#212529', lineHeight: 1.5, fontWeight: 600 }}>
                            <span style={{ fontWeight: 'bold', marginRight: "5px" }}>Revised ETA: </span>
                            <span>{revised_eta}</span>
                        </span>
                    </div> : ""}


                <div id="timeline-container1" className="timeline-container1">
                    {/* <style>
                        {`
                            .timeline-stripe1::before {
                                height: ${greenLineHeight}px;
                            }
                        `}
                    </style> */}
                    <style>
                        {`
                        .timeline-stripe1::before {
                            height: ${greenLineHeight}px;
                            top: ${greenLineTopOffset}px;
                        }
                    `}
                    </style>

                    <div className={`timeline-stripe1 ${showAllInTransit ? "expanding" : ""}`}>
                        {uniqueTimelineData.length > 0 ? uniqueTimelineData.map((event, index) => {
                            const status = (event.intransit_status || event.current_loc_status || "").toLowerCase().trim();
                            const isInTransit = status === "in transit";
                            const isGreenLine = showAllInTransit && isInTransit && index >= firstInTransitIndex && index <= lastInTransitIndex;
                            return (
                                <div
                                    // className={`timeline-event1 ${index <= lastInTransitIndex ? 'line-green' : 'line-blue'} ${event.newlyShown ? 'newly-shown' : ''}`}
                                    className={`timeline-event1 ${isGreenLine ? 'line-green' : 'line-blue'} ${event.newlyShown ? 'newly-shown' : ''}`}
                                    key={index}
                                >
                                    <div
                                        className={`timeline-dot1 ${index === 0
                                            ? 'truck-image1'
                                            : isInTransit && showAllInTransit
                                                ? 'green-dot1'
                                                : 'blue-dot1'
                                            } ${index === 0 && showAllInTransit ? 'expanded' : ''}`}

                                        onClick={() => {
                                            if (index === 0 && inTransitEvents.length > 1) {
                                                setShowAllInTransit(prev => !prev);
                                            }
                                        }}
                                        title={index === 0 && inTransitEvents.length > 1 ? (showAllInTransit ? "Show Less" : "Show More") : ""}
                                        style={{ cursor: index === 0 && inTransitEvents.length > 1 ? 'pointer' : 'default' }}
                                    >

                                        {index === 0 && (
                                            <div className={`truck-wrapper ${showAllInTransit ? 'expanded-arrow' : 'collapsed-arrow'}`}>
                                                <img
                                                    src={require("../../assets/images/truck_img.png")}
                                                    alt="Truck"
                                                    className="truck-image-icon1"
                                                />
                                                <span className="arrow-toggle">
                                                    {showAllInTransit ? '' : '▶'}
                                                </span>
                                            </div>

                                        )}
                                    </div>
                                    <div className={`timeline-content1 ${isInTransit && showAllInTransit ? 'in-transit-bg' : ''}`}>
                                        <p>
                                            <strong>
                                                {event.transitdatetime ? (() => {
                                                    return getFormattedTransitdate(event.transitdatetime);
                                                })() : ""}
                                            </strong>
                                        </p>
                                        {event.intransit_location && <p>Location: {event.intransit_location}</p>}
                                        <p><strong>Status:</strong> {event.intransit_status?.trim() || event.current_loc_status?.trim() || ""}</p>
                                        {event.city && <p><strong>Location:</strong> {event.city}</p>}
                                        {event.late_delivery_remarks && <p><strong>Late Delivery Remarks:</strong> {event.late_delivery_remarks}</p>}
                                        {/* {event.undeliveredRemarks && <p><strong>Undelivered Reason:</strong> {event.undeliveredRemarks}</p>} */}
                                        {event.remarks
                                            ? <p>Remarks: {event.remarks}</p>
                                            : event.undeliveredRemarks && <p><strong>Remarks:</strong> {event.undeliveredRemarks}</p>
                                        }
                                        {event.timestamp && (
                                            <p>
                                                <strong>Time:</strong>{" "}
                                                {moment(event.timestamp).format("DD-MM-YYYY HH:mm")}
                                            </p>
                                        )}
                                        {event.force_closure_reason && <p>Force Closure Reason: {event.force_closure_reason}</p>}
                                        {/* {event.remarks && <p>Remarks: {event.remarks}</p>} */}
                                        {isInTransit && event.legs && event.legs.length > 0 && (
                                            <div
                                                className="expand-legs-icon"
                                                title={expandedLegsIndex === index ? "Collapse Legs" : "Expand Legs"}
                                                style={{ cursor: 'pointer', marginTop: '5px', color: '#28a745' }}
                                                onClick={() => setExpandedLegsIndex(expandedLegsIndex === index ? null : index)}
                                            >
                                                {expandedLegsIndex === index ? '▼ Hide Cities' : '▶ Show Cities'}
                                            </div>
                                        )}
                                        {expandedLegsIndex === index && event.legs && event.legs.length > 0 && (
                                            <div className="legs-container">
                                                {event.legs.map((leg, i) => (
                                                    <div key={i} className="leg-details">
                                                        <p><strong>Location:</strong> {leg.city}</p>
                                                        <p><strong>Status:</strong> {leg.current_loc_status}</p>
                                                        <p><strong>Time:</strong> {moment(leg.timestamp).format("DD-MM-YYYY HH:mm")}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        }) : (
                            <p>No timeline available</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimelineModal;